import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { periodParamSchema } from '@/screens/mutual-funds/search'

/**
 * `/mutual-funds/monthly-holdings` — the page the 2026-11-03 mock folded into Industry holdings
 * as "All sectors" (its opening view). An old link or bookmark lands there, on the same month.
 */
export const Route = createFileRoute('/_app/mutual-funds/monthly-holdings')({
  validateSearch: z.object({ period: periodParamSchema }),
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/mutual-funds/industry-holdings',
      search: search.period === undefined ? {} : { period: search.period },
      replace: true,
    })
  },
  component: () => null,
})
